export default __webpack_public_path__ + "static/media/check-facial.08385652.svg";